module.exports = fox._r("images/faq-icon-name.png", __webpack_public_path__ + "images/faq-icon-name.png");


//////////////////
// WEBPACK FOOTER
// ./images/faq-icon-name.png
// module id = 10
// module chunks = 2